<ng-template #template>
    <!-- <h5 class="modal-title pull-left"> Add Roles</h5> -->
    <!-- <div class="modal-body p-2">
    </div>
    -->
    <div class="image-container-box">
        <button class="close-icon" (click)="closeLightbox()">
            <img src="../../../../assets/images/icons/close-icon.png" class="close-btn-img">
        </button>
<div class="image-box align-items-center">

</div>
    <img src="{{imageUrl}}" alt="" class="img-fluid"> 
    </div>
 
</ng-template>